import { Track } from '../../classes/track'
import { toDateString } from '../../filters'
import { REKORDCLOUD_COLOR_HEX_MAP } from '../color'

export function ratingCellRenderer(params: any): string | null {
  if (!params.data) return null

  const rating: number = params.data.rating

  if (rating) {
    const stars: number = (rating / 255) * 5

    let s: string = `<div class="rating">`

    for (let i = 0; i < stars; i++) {
      s += `<i class="star">⭐</i>`
    }

    if (stars % 1 === 0.5) {
      s += `<i class="star half">⭐</i>`
    }

    s += `</div>`

    return s
  } else {
    return null
  }
}

export function colorCellRenderer(params: any): string | null {
  const color: string = params.value
  const colorFriendly: string = color ? color.replace(/_/g, ' ') : ''

  if (color) {
    return `<div class="flex flex-align-center full-height"><span title="${colorFriendly}" class="color-dot" style="background-color: ${REKORDCLOUD_COLOR_HEX_MAP[color]}"></span>${colorFriendly}</div>`
  } else {
    return null
  }
}

export function dateCellRenderer(params: { data: Track }): string | null {
  if (!params.data.dateImported) return null

  return toDateString(params.data.dateImported)
}
